import { Logger } from '..'

const eventId = 'dummy-id'

const consoleLogger: Logger = {
  captureException: (e) => {
    console.error(e)
    return eventId
  },
}

export default consoleLogger
